export const ROUTE_LANDING_PAGE = "/";
export const ROUTE_SUCCESS_PAGE = "/success";
export const ROUTE_ABANDONED_PAGE = "/abandoned";
export const ROUTE_ERROR_PAGE = "/error";
export const ROUTE_GENERIC_PAGE = "/education";
export const ROUTE_INSTA_EDUCATION_PAGE = "/insta-education";
export const ROUTE_INVITE_EXPIRED = "/invite-expired";
export const ROUTE_CONNECTION_STEPS = "/connection-steps";

